import { ViewHeader2Page } from "./../view-header2/view-header2";
import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { HomePage } from "./../home/home";
import { QuizPage } from "./../quiz/quiz";
import { ShopperSelectTeamPage } from "./../shopper-select-team/shopper-select-team";
import { MerchantSelectTeamPage } from "./../merchant-select-team/merchant-select-team";
import { PlazaSelectTeamPage } from "./../plaza-select-team/plaza-select-team";
import { ServiceProvider } from "./../../providers/service/service";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { Http, RequestOptions, Headers } from "@angular/http";
import "rxjs/add/operator/map";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";

@IonicPage()
@Component({
  selector: "page-select-language",
  templateUrl: "select-language.html",
})
export class SelectLanguagePage {
  languageList: any;
  language: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private services: ServiceProvider,
    private storage: Storage,
    private http: Http,
    public translateService: TranslateService,
    public loadingCtrl: LoadingController
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("token").then((token) => {
      var link = this.services.URLLanguage;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.languageList = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  selectLang(lang) {
    this.language = lang;
  }

  next() {
    if (this.language == "" || !this.language) {
      this.translateService.get("error select language").subscribe((value) => {
        this.services.presentToast(value);
      });
    } else {
      const loader = this.loadingCtrl.create({
        content: "Loading...",
      });
      loader.present();

      this.translateService.use(this.language.trim());
      this.storage.set("stepGame", "selectTeam");
      this.storage.set("language", this.language);

      this.storage.get("token").then((token) => {
        var link = this.services.URLGameState;
        var headers = new Headers();
        headers.append("Accept", "application/json");
        headers.append("Authorization", "Bearer " + token);
        const requestOptions = new RequestOptions({ headers: headers });

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (res_state) => {
              if (res_state.step == 1) {
                this.storage.get("info").then((info) => {
                  if (info.role == 1) {
                    this.navCtrl.setRoot(PlazaSelectTeamPage);
                  } else if (info.role == 2) {
                    this.navCtrl.setRoot(MerchantSelectTeamPage);
                  } else if (info.role == 3) {
                    this.navCtrl.setRoot(ShopperSelectTeamPage);
                  }
                });
              } else if (res_state.step == 2) {
                this.storage.set("stepGame", "quiz");
                this.storage.set("quizRound", "1");
                this.navCtrl.setRoot(QuizPage);
              } else {
                this.storage.set("stepGame", "home");
                this.storage.get("info").then((info) => {
                  if (info.role == 1) {
                    this.navCtrl.setRoot(HomePage);
                  } else if (info.role == 2) {
                    this.navCtrl.setRoot(MerchantHomePage);
                  } else if (info.role == 3) {
                    this.navCtrl.setRoot(ShopperHomePage);
                  }
                });
              }

              var link2 = this.services.URLVideo;

              this.http
                .get(link2, requestOptions)
                .map((res) => res.json())
                .subscribe(
                  (data) => {
                    this.storage.set("video", data);
                  },
                  (error) => {
                    var response = JSON.parse(error._body);

                    this.translateService
                      .get(response.message)
                      .subscribe((value) => {
                        this.services.presentToast(value);
                      });
                  }
                );

              // var link3 = "https://theplaza-v2.ingenious-simulation.com/v1/translations?token=02ab88616c5bbdd5bbcbe82ca0a300e917570d3e&language="+this.language;
              // var headers2 = new Headers();
              // headers2.append("Accept", 'application/json');
              // const requestOptions2 = new RequestOptions({ headers: headers2 });

              // this.http.get( link3, requestOptions2 ).map(res => res.json()).subscribe(data => {

              //   console.log("data", data);

              // }, error => {

              //   var response = JSON.parse(error._body);

              //   this.translateService.get(response.message).subscribe(
              //     value => {
              //       this.services.presentToast(value);
              //     }
              //   );

              // });

              loader.dismiss();
            },
            (error) => {
              var response = JSON.parse(error._body);
              loader.dismiss();
              this.translateService.get(response.message).subscribe((value) => {
                this.services.presentToast(value);
              });
            }
          );
      });
    }
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeader2Page);
  }
}



// WEBPACK FOOTER //
// ./src/pages/select-language/select-language.ts